import { Card, CardBody, Spinner } from '@heroui/react';
import React from 'react';

interface FormattedPrediction {
  placeId: string;
  description: string;
}

interface PredictionsListProps {
  predictions: FormattedPrediction[];
  loading: boolean;
  onPredictionClick: (prediction: FormattedPrediction) => void;
  showPredictions?: boolean;
  onCreateCustomBuyerClick: () => void;
  showCustomOption?: boolean;
}

export const PredictionsList: React.FC<PredictionsListProps> = ({
  predictions,
  loading,
  onPredictionClick,
  showPredictions = true,
  onCreateCustomBuyerClick,
  showCustomOption = true,
}) => {
  if (!showPredictions) return null;

  if (loading) {
    return (
      <Card className="absolute top-16 w-full z-10 shadow-lg">
        <CardBody className="p-4">
          <div className="flex items-center justify-center gap-2">
            <Spinner size="sm" />
            <span className="text-sm text-default-600">
              Loading Place Predictions...
            </span>
          </div>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card className="absolute top-16 w-full z-10 shadow-lg">
      <CardBody className="p-0">
        <ul className="list-none m-0">
          {predictions.map((prediction, index) => (
            <li
              key={prediction.placeId}
              className="px-4 py-3 hover:bg-default-100 cursor-pointer border-b border-divider last:border-b-0 transition-colors"
              onClick={() => onPredictionClick(prediction)}
              tabIndex={index}
            >
              <div className="flex items-start gap-3">
                <div className="mt-0.5">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-default-500"
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <div className="flex flex-col w-full">
                  <span className="text-sm font-medium text-foreground">
                    {prediction.description}
                  </span>
                </div>
              </div>
            </li>
          ))}
          {predictions.length > 0 && showCustomOption && (
            <hr className="border-divider" />
          )}
          {showCustomOption && (
            <li
              className="px-4 py-3 hover:bg-default-100 cursor-pointer transition-colors"
              onClick={onCreateCustomBuyerClick}
            >
              <div className="flex items-center gap-3">
                <span className="text-primary">+</span>
                <span className="text-sm text-foreground">
                  Create custom Buyer
                </span>
              </div>
            </li>
          )}
        </ul>
      </CardBody>
    </Card>
  );
};
